import { Column, EntityId, Label, Row } from '@ydistri/ds';
import { SkuDescriptionResponse } from '@ydistri/api-sdk';
import { Typography } from 'antd';
import React from 'react';
import { useClipboardHandlers } from '../../../lib/hooks/useClipboardHandlers';
import { styled } from 'styled-components';
import { COLORS } from '../../../styles/style';

interface SkuDescriptionProps {
  skuDescription?: SkuDescriptionResponse;
  hideLabel?: boolean;
  showActualData?: boolean;
}

const htmlParagraphStyle: React.CSSProperties = {
  marginBottom: 0,
};

const SkuDescriptionContent = styled.div<{ showActualData?: boolean }>`
  max-width: 90%;
`;

const SkuDescriptionWrapper = styled(Row)<{ showActualData?: boolean }>`
  color: ${props => (props.showActualData ? COLORS.PRIMARY : 'inherit')};
`;

/**
 * Displays the SKU description which may contain HTML content.
 */
const SkuDescription: React.FC<SkuDescriptionProps> = ({
  skuDescription,
  hideLabel = false,
  showActualData = false,
}) => {
  const clipboardHandlers = useClipboardHandlers();

  if (skuDescription) {
    /* eslint-disable @typescript-eslint/naming-convention -- mandatory convention */
    const body = (
      <Typography.Paragraph style={htmlParagraphStyle}>
        <SkuDescriptionWrapper
          $alignItems="flex-start"
          $gap="0.5rem"
          showActualData={showActualData}
        >
          <SkuDescriptionContent dangerouslySetInnerHTML={{ __html: skuDescription.value }} />
          <EntityId systemId={skuDescription.id} id={null} {...clipboardHandlers} />
        </SkuDescriptionWrapper>
      </Typography.Paragraph>
    );

    if (hideLabel) {
      return body;
    } else {
      return (
        <Column $gap="0.5rem" $padding={0.5}>
          <Label $size="xLarge">Description</Label>
          {body}
        </Column>
      );
    }
  }
};

export default SkuDescription;
